import React from 'react';
import { motion } from 'framer-motion';

interface ShimmerEffectProps {
  children: React.ReactNode;
  className?: string;
}

const ShimmerEffect: React.FC<ShimmerEffectProps> = ({ children, className = '' }) => {
  return (
    <motion.div
      className={`relative overflow-hidden ${className}`}
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
    >
      {children}
      <motion.div
        className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent"
        initial={{ x: '-100%' }}
        animate={{ x: '100%' }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
        style={{ opacity: 0.3 }}
      />
    </motion.div>
  );
};

export default ShimmerEffect;
